export default {"src":"/_next/static/media/icon_header_chat.a97f12f4.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};